import styled from 'styled-components';
import { Colors } from '../../../assets/styles/colors';

export const ReceiptButtonInput = styled.input`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
`;

export const ReceiptButtonLabel = styled.div``;

export const ReceiptButton = styled.div`
  width: 100%;
  display: flex;
  background: white;
  gap: 4px;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  color: ${Colors.PrimaryMain};
  font-size: 14px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.5px;
  border: 1px solid ${Colors.PrimaryMain};
  position: relative;
  cursor: pointer;
`;

export const ModalHeadTitle = styled.div`
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: ${Colors.TextMain};
`;

export const ModalHeadCTA = styled.div<{ clickable?: boolean }>`
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${((props) => {
    if (props.clickable) {
      return `
        cursor: pointer;
        color: #187DA1;
      `;
    }

    return '';
  })}
`;

export const ModalHead = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  background: white;
  display: flex;
  width: 100%;
  align-items: center;
`;

export const ModalBody = styled.div`
  width: 100%;
  height: 100%;
  background: white;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
`;

export const ModalContent = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background: ${Colors.TextMain};
  padding: 16px 32px;
  overflow: hidden;
`;

export const ModalImage = styled.img`
  display: block;
  flex: 1;
  object-fit: contain;
  object-position: center;
  max-width: 100%;
  max-height: 100%;
`;

export const ModalFooter = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 32px 16px;
  background: white;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;

  button {
    flex: 1;
  }
`;

export const ImagePreviewWrapperActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: baseline;

  button {
    color: ${Colors.TextSecondary};
  }
`;

export const ImagePreview = styled.img`
  width: 120px;
  max-height: 200px;
  object-fit: contain;
  object-position: center;
`;

export const ImagePreviewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;
